import React from 'react'
import { Link } from "react-router-dom";
import { useTranslation, Trans  } from 'react-i18next';

const AboutBox = () => {
  const { t } = useTranslation();

    return (
        <section className="knsl-p-100-100">
          <div className="container">
            <div className="knsl-about-card">
              <div className="row no-gutters">
                <div className="col-lg-6">
                  <div className="knsl-about-photo">
                    <img src="assets/img/about/t1.jpg" alt="cover" />
                  </div>
                </div>
                <div className="col-lg-6 align-self-center">
                  <div className="knsl-about-text">
                    <div className="knsl-title-frame">
                      <h2 className="knsl-mb-20">
                        <Trans i18nKey="main.aboutTitle1">
                          We have 17+ years <code /> of Experience.
                        </Trans>
                      </h2>
                      <p className="knsl-mb-30">{t('main.aboutDesc1')}</p>
                      <Link to="/about" className="knsl-btn knsl-btn-md">{t('main.moreAbout')}</Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 order-lg-2">
                  <div className="knsl-about-photo">
                    <img src="assets/img/about/t2.jpg" alt="cover" />
                  </div>
                </div>
                <div className="col-lg-6 align-self-center">
                  <div className="knsl-about-text">
                    <div className="knsl-title-frame">
                      <h2 className="knsl-mb-20"> {t('main.aboutTitle2')}</h2>
                      <p className="knsl-mb-30">{t('main.aboutDesc2')}</p>
                      <Link to="/rooms" className="knsl-btn knsl-btn-md">{t('main.chooseRoom')}</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    )
}

export default AboutBox